var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiWhitePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    width: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.467 13.395v-5.27H1.203a.656.656 0 01-.633-.638v-.94a.66.66 0 01.639-.639h5.258V.605C6.467.269 6.764 0 7.1 0h.94c.337 0 .634.269.634.605v5.303h5.291c.336 0 .605.302.605.638v.941c0 .336-.269.639-.605.639H8.674v5.27c0 .335-.297.604-.633.604H7.1c-.336 0-.633-.269-.633-.605z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--white-plus-3beb15d0e658ae553d6c2b8f9777b5c6.svg";
export { SvgIconUiWhitePlus as Component };